import axios from "axios";
import { base_url } from "../../utils/baseUrl";



const getAsegoBookings = async () => {

    const response = await axios.get(`${base_url}policy/asego-booking`);

    return response.data;

};
const createAsegoBooking = async (values) => {
    const response = await axios.post(`${base_url}AsegoBooking/addAsegoBooking`, values);

    return response.data;
};

const updateAsegoBooking = async (values) => {
    const id = values.id
    const response = await axios.put(
        `${base_url}AsegoBooking/editAsegoBooking/${id}`,
        values,

    );

    return response.data;
};
const updateAsegoBookingStatus = async (values) => {
    console.log(values, "status")
    const id = values.id
    const response = await axios.put(
        `${base_url}AsegoBooking/approve-supplier/${id}`,
        values,
        {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            },
        }

    );

    return response.data;
};

const getAsegoBooking = async (id) => {
    const response = await axios.get(`${base_url}AsegoBooking/getById/${id}`);
    return response.data;
};

const deleteAsegoBooking = async (id) => {
    const response = await axios.delete(`${base_url}AsegoBooking/deleteAsegoBooking/${id}`);

    return response.data;
};
const AsegoBookingService = {
    getAsegoBookings,
    createAsegoBooking,
    getAsegoBooking,
    updateAsegoBooking,
    updateAsegoBookingStatus,
    deleteAsegoBooking,
};

export default AsegoBookingService;
